import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=5147b79a&scoped=true"
import script from "./CSelect.vue?vue&type=script&lang=js"
export * from "./CSelect.vue?vue&type=script&lang=js"
import style0 from "./CSelect.vue?vue&type=style&index=0&id=5147b79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147b79a",
  null
  
)

export default component.exports